<template>
  <svg
    :width="width"
    :height="height"
    :stroke="stroke"
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
    class="loader"
  >
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(1 1)" stroke-width="2">
        <circle stroke-opacity="0.5" cx="18" cy="18" r="18"></circle>
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          ></animateTransform>
        </path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'loader',

  props: {
    width: {
      type: String,
      default: '20',
    },
    height: {
      type: String,
      default: '20',
    },
    stroke: {
      type: String,
      default: '#fff',
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
</style>
